<script>
    import { theme } from "../stores/store";
    export let data;
</script>

{#if Object.keys(data).length>0}
    <p 
        class:text-secondary={$theme=='CLARO'}
        class:text-white={$theme=='OSCURO'} 
    >
        <strong>{data.resultados}</strong> Registros encontrados<br/>
        Página actual <strong>{data.pagina_actual+1}</strong> de <strong>{data.paginas}</strong>
    </p>
{/if}

<style>
P {
    line-height:1rem !important;
    font-size: 0.8rem !important;
}
</style>